import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Refund Policy | Manav Adhikar Forum</title>
        <meta
          name="description"
          content="Refund Policy for using the Manav Adhikar Forum website."
        />
        <meta
          name="keywords"
          content="Manav Adhikar Forum, refund policy, human rights, equality, justice, India, MAF, awareness, campaigns"
        />
        <link
          rel="canonical"
          href="https://manavadhikarforum.in/Refund-Policy"
        />
      </Helmet>
      <Container className="my-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <Card className="shadow-sm">
              <Card.Header
                as="h1"
                className="text-center bg-primary text-white"
              >
                Refund Policy
              </Card.Header>
              <Card.Body>
                <p className="lead text-center text-muted fw-medium">
                  Manav Adhikar Forum - A Human Rights NGO
                </p>
                <hr />

                <h4 className="mt-4 text-danger">No Refund Policy</h4>
                <p>
                  As a non-profit human rights organization, all donations made
                  to the Manav Adhikar Forum are final. We do not offer refunds
                  on any donations under any circumstances.
                </p>

                <p>
                  Your donation is an act of generosity that helps us continue
                  our vital work of promoting and protecting human rights. The
                  funds are immediately allocated to support our various
                  campaigns, legal aid services, and advocacy efforts.
                </p>

                <p>
                  By making a donation, you acknowledge and agree to this
                  no-refund policy. We are grateful for your support and
                  understanding that your contribution is a gift to further our
                  mission.
                </p>

                <h4 className="mt-5">Contact Us</h4>
                <p>
                  If you have any questions or concerns regarding your donation,
                  please do not hesitate to contact us. We are happy to provide
                  information on how your contribution is making a difference.
                  <br />
                  Email:{" "}
                  <a href="mailto:manavadhikarforumindia@gmail.com">
                    manavadhikarforumindia@gmail.com
                  </a>
                  <br />
                  Address: 2nd -FR, FL-C-3, Holding No-53, Ramkrishna Garh Road,
                  Manickpur, LP-110/31/10/1, Kolkata, West Bengal-700079
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RefundPolicy;
